import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Box,
} from "@mui/material";
import { CustomButton } from "./Button";
import TextInput from "./TextInput";
import SwapVertIcon from "@mui/icons-material/SwapVert";
type TableProps = {
  users: any;
  columns: any;
  page: number;
  rowsPerPage: number;
  handleChangePage: any;
  handleLimitChange: any;
  loader: boolean;
  count: number;
  sortByColumn: any;
};

const TableComponent: React.FC<TableProps> = ({
  users,
  columns,
  page,
  rowsPerPage,
  handleChangePage,
  loader,
  handleLimitChange,
  count,
  sortByColumn,
}) => {
  return (
    <Paper sx={{ borderRadius: 2, overflow: "hidden" }}>
      <Box
        sx={{
          overflowX: "auto",
          maxHeight: "450px",
          "&::-webkit-scrollbar-track": {
            borderRadius: "1px",
          },
        }}
      >
        <Table stickyHeader sx={{ backgroundColor: "white" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              {columns
                .map((col: any) => col.header)
                .map((text: string) => (
                  <TableCell
                    key={text}
                    sx={{
                      position: "sticky",
                      top: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 1,
                      color: "#000",
                      fontWeight: "bold",
                      fontFamily: "Poppins !important",
                      whiteSpace: "nowrap",
                      textAlign: "center",
                    }}
                  >
                    {text}
                    {columns.find((col: any) => col.header === text)?.sort && (
                      <div
                        style={{
                          position: "absolute",
                          right: text === "Email" ? "50px" : "-5px",
                          top: "13px",
                          cursor: "pointer",
                        }}
                        onClick={() => sortByColumn(text)}
                      >
                        <SwapVertIcon sx={{ fontSize: "17px" }} />
                      </div>
                    )}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user: any) => (
              <TableRow
                key={user.id}
                sx={{
                  backgroundColor: "#e6f4ea",
                  fontFamily: "Poppins !important",
                }}
              >
                {columns.map((column: any) => {
                  return column.type === "button" ? (
                    <TableCell>
                      <CustomButton
                        text={user[column.key] || column.text}
                        bgcolor={
                          user[column.key] == "Disabled"
                            ? "#c7503d"
                            : column.bgcolor
                        }
                        color={
                          column.key == "resetPassword" &&
                          user.isExternalAccount
                            ? "lightgrey !important"
                            : "white"
                        }
                        width="max-content"
                        submit={() =>
                          column.onSubmit(
                            column.key == "accountStatus"
                              ? user[column.key] == "Active"
                                ? "Disabled"
                                : "Active"
                              : "",
                            user.username
                          )
                        }
                        disabled={
                          column.key == "resetPassword" &&
                          user.isExternalAccount
                        }
                      />
                    </TableCell>
                  ) : (
                    <TableCell
                      sx={{
                        color: "#000",
                        fontFamily: "Poppins !important",
                        textAlign: "center",
                      }}
                    >
                      {column.type === "boolean" ? (
                        user[column.key] ? (
                          "Yes"
                        ) : (
                          "No"
                        )
                      ) : column.type == "date" ? (
                        user[column.key] ? (
                          new Date(user[column.key])
                            .toLocaleString("en-US", {
                              month: "long",
                              day: "numeric",
                              year: "numeric",
                            })
                            .replace(" at ", ", ")
                        ) : (
                          "-"
                        )
                      ) : column.type == "input" ? (
                        <TextInput
                          defaultValue={user[column.key]}
                          type="number"
                          bgcolor={column.bgcolor}
                          color="white"
                          width="80px"
                          handleKeyUp={(e) =>
                            column.onSubmit(e, user[column.key], user.username)
                          }
                          disabled={column.disabled}
                        />
                      ) : (
                        user[column.key] || "-"
                      )}
                    </TableCell>
                  );
                })}
              </TableRow>
            ))}
            {/* )} */}
          </TableBody>
        </Table>
      </Box>

      {/* Pagination container */}
      <Box sx={{ backgroundColor: "#e6f4ea" }}>
        <TablePagination
          component="div"
          count={count}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleLimitChange}
          rowsPerPageOptions={[5, 10, 25]}
          labelRowsPerPage="Rows per page:"
          sx={{
            color: "#000",
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                color: "#000",
              },
            "& .MuiTablePagination-actions": {
              color: "#000",
            },
            "& .MuiInputBase-root": {
              color: "#000",
            },
            "& .MuiSvgIcon-root": {
              color: "#000",
            },
            px: 2,
            display: "flex",
            justifyContent: "flex-start",
          }}
        />
      </Box>
    </Paper>
  );
};

export default TableComponent;
